<div *ngIf="runReportDialog"
  class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
  <div class="h-full w-full flex justify-center items-center">
    <div *ngIf="runReportDialog"
      class="items-center justify-center rounded-lg bg-white p-3 absolute text-center min-w-[500px] max-w-[750px] max-h-[600px] overflow-y-scroll">
      <h2 class="mb-2 text-lg font-bold">
        Run Report
      </h2>
      <!--<div class="flex justify-between items-center mt-1">
        Choose Exam Mode
        <select [(ngModel)]="reportMode" class="block rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
          <option value="STANDARD">
            Standard
          </option>
          <option value="PRACTICE">
            Practice
          </option>
          <option value="PREVIEW">
            Preview
          </option>
        </select>
      </div>
      <div class="flex justify-between items-center mt-1">
        Enter Exam Start Date:
        <input
          type="date"
          [(ngModel)]="reportRequiredStart"
          class="rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
      </div>
      <div class="flex justify-between items-center mt-1">
        Enter Exam End Date:
        <input
          type="date"
          [(ngModel)]="reportRequiredFinish"
          class="rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
      </div>-->
      <div class="flex justify-between items-center mt-1">
        Graded Exam?
        <input [(ngModel)]="reportRequiredGrade" type="checkbox" [style]="accentPrimaryColor">
      </div>
      @if (reportHeaders.length > 0) {
      <div class="my-3 flex justify-between">
        <div>
          Filter your CSV:
        </div>
        <div class="flex gap-5">
          <input type="text" placeholder="Filter Value" class="input" [(ngModel)]="filter_column_string" />
          <select [(ngModel)]="filter_column_index"
            class="block max-w-[210px] rounded-md border-0 px-3.5 py-2 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6">
            @for (column_name of reportHeaders; track column_name; let i = $index) {
            <option [value]="i">{{column_name}}</option>
            }
          </select>
        </div>
      </div>
      }
      <div class="flex justify-between mt-6">
        <outline-button [marginRight]="true" (click)="cancelRunReport()" text="Cancel" />
        <full-button (click)="runReport()" text="Run" />
      </div>
      <div *ngIf="reportRunIsSuccess" class="mt-3">
        <div class="mb-2 flex justify-between items-center">
          <p class="font-bold">
            Report Result
          </p>
          <clear-button (click)="downloadCSV()" [faIcon]="faDownload" text="Download CSV" />
        </div>
        <div class="overflow-y-auto">
          <table class="preview-table">
            <tr>
              <th *ngFor="let column_name of reportHeaders">
                {{column_name}}
              </th>
            </tr>
            <tr *ngFor="let column_array of reportValues.slice(0, 5)">
              <td *ngFor="let cell of column_array">
                <!-- TODO figure out if cell type Date -->
                @if (isISO8601(cell)) {
                {{cell | date:'short'}}
                } @else {
                {{cell}}
                }
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="reportValues.length > 5" class="flex justify-end">
          ... plus {{reportValues.length - 5}} more rows
        </div>
      </div>
    </div>
  </div>
</div>
<breadcrumb endText="Exam Export List" [navigations]="breadcrumbNavs" />
<div class="p-2 lg:pb-2 lg:m-5">
  <div class="flex justify-between items-center">
    <h1 class="text-xl font-semibold">
      Exam CSV Export List
    </h1>
    <outline-button [faIcon]="faAdd" (click)="createNewCSV()" text="Create CSV" />
  </div>
  <table class="mt-4 w-full table-fixed border-separate border-spacing-0">
    <thead>
      <tr class="h-[48px] text-left text-gray-500 text-xs font-semibold uppercase leading-tight">
        <th scope="col" class="w-1/2 bg-[#F4F6F8] rounded-l-[4px] pl-[16px] lg:pl-[64px] pr-1 font-semibold">
          Name
        </th>
        <th scope="col" class="bg-[#F4F6F8] px-1 font-semibold">
          Last Updated
        </th>
        <th scope="col" class="bg-[#F4F6F8] rounded-r-[4px] pl-1 pr-[16px] font-semibold">
          Actions
        </th>
      </tr>
    </thead>
    <tbody>
      @for (report of examReports; track report) {
      <tr class="hover:bg-[#F9FAFB] transition-colors">
        <td class="pl-[16px] lg:pl-[64px] pr-1 py-3 align-middle border-b border-[#F1F3F5] text-sm">
          <div class="truncate font-medium text-black/90">{{report.name}}</div>
        </td>
        <td class="px-1 py-3 align-middle border-b border-[#F1F3F5] text-gray-600 text-sm">
          {{report.lastupdated | date: 'short'}}
        </td>
        <td class="pl-1 pr-[16px] py-3 align-middle border-b border-[#F1F3F5]">
          <div class="flex gap-[8px]">
            <dropdown-menu [menuItems]="report.menuItems" aria-label="Exam Report Menu" appearance="outlined" />
          </div>
        </td>
      </tr>
      } @empty {
      <tr>
        <td colspan="3" class="py-10 text-center text-sm text-gray-500">
          No exam reports to show
        </td>
      </tr>
      }
    </tbody>
  </table>
  <per-page-pagination *ngIf="examReports.length !== 0" [currentPagination]="currentPagination" perPageText="Reports"
    (perPageFunction)="handleServiceCall()" (incrementPageFunction)="handleServiceCall()"
    (decrementPageFunction)="handleServiceCall()" />

  @if (showDeleteDialog) {
  <app-delete-confirmation [message]="'Are you sure you want to delete this Report?'" (confirm)="confirmDelete()"
    (cancel)="showDeleteDialog = false">
  </app-delete-confirmation>
  }

</div>